import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "position-absolute photos-list-content-title-name bg-dark bg-opacity-75 clickable text-small ps-1 pe-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#photo-modal-component"
}
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "mb-1 text-uppercase"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_5 = {
  key: 0,
  class: "mb-1 mt-1"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_7 = {
  key: 4,
  class: "position-absolute photos-list-cart-add-remove-buttons-container ms-2"
}
const _hoisted_8 = {
  key: 5,
  class: "position-absolute bg-danger bg-opacity-75 text-medium fw-bold p-1 top-0 start-0 end-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoThumbnail = _resolveComponent("PhotoThumbnail")!
  const _component_ButtonAddToCart = _resolveComponent("ButtonAddToCart")!
  const _component_ButtonRemoveFromCart = _resolveComponent("ButtonRemoveFromCart")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative photo-list-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
  }, [
    (_ctx.isModalTriggering)
      ? (_openBlock(), _createBlock(_component_PhotoThumbnail, {
          key: 0,
          class: "photo-list-img clickable",
          photoId: _ctx.item.id,
          quality: '240',
          textAlternative: _ctx.item.title,
          "data-bs-toggle": "modal",
          "data-bs-target": "#photo-modal-component"
        }, null, 8, ["photoId", "textAlternative"]))
      : (_openBlock(), _createBlock(_component_PhotoThumbnail, {
          key: 1,
          class: _normalizeClass(_ctx.photoThumbnailClass),
          photoId: _ctx.item.id,
          quality: '720',
          textAlternative: _ctx.item.title
        }, null, 8, ["class", "photoId", "textAlternative"])),
    (_ctx.isModalTriggering)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.item.timestamp_created.replace("T", ' ')), 1),
          (_ctx.item.title)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.item.title), 1))
            : _createCommentVNode("", true),
          (_ctx.item.legend)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.getLegend(_ctx.item.legend)), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['position-absolute photos-list-content-title-name bg-dark bg-opacity-75 text-small ps-1 pe-1' + (_ctx.item.title !== '' ? ' clickable': ''), "position-absolute photos-list-content-title-name bg-dark bg-opacity-75 clickable text-small ps-1 pe-1"])
        }, [
          (_ctx.item.title)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.item.title), 1))
            : _createCommentVNode("", true),
          (_ctx.item.legend)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.getLegend(_ctx.item.legend)), 1))
            : _createCommentVNode("", true)
        ], 2)),
    (!_ctx.isHome && _ctx.hasCartAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_ButtonAddToCart, {
            item: _ctx.item,
            canHide: true
          }, null, 8, ["item"]),
          _createVNode(_component_ButtonRemoveFromCart, {
            item: _ctx.item,
            canHide: true
          }, null, 8, ["item"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isModalTriggering && _ctx.item.title === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.languageStore.text(_ctx.TEXT_KEYS.PHOTO_ITEM_LIST_HOME_NO_TITLE)), 1))
      : _createCommentVNode("", true)
  ]))
}